import type { Dayjs } from 'dayjs';

import type { UserModel } from './user';
import type { PaginatorResponse } from './common';

// Enums que coinciden con el backend
export enum ExpensePaymentMethodEnum {
  Wise = 0,
  PayPal = 1,
  Crypto = 2,
}

export enum ExpenseCurrencyEnum {
  EUR = 0,
  GBP = 1,
  USD = 2,
  MXN = 3,
  ARS = 4,
  COP = 5,
  CLP = 6,
  PEN = 7,
}

export enum ExpenseStatusEnum {
  Pending = 0,
  Paid = 1,
}

export enum ExpenseTypeEnum {
  Service = 1,
  Order = 2,
  Team = 3,
  Sponsorships = 4,
}

// Modelo principal de gasto externo
export interface ExpenseInvoiceModel {
  id: number;
  name: string;
  concept: string;
  providerEmail: string;
  paymentMethod: ExpensePaymentMethodEnum;
  language: string;
  currency: ExpenseCurrencyEnum;
  amount: number;
  status: ExpenseStatusEnum;
  fileName?: string;
  fileUrl?: string;
  fileContentType?: string;
  fileSize?: number;
  createdDate: Date;
  updatedDate?: Date;
  paidDate?: Date;
  createdByUserId: number;
  createdByUser?: UserModel;
  expenseType: ExpenseTypeEnum;
  expenseInvoiceOrders?: ExpenseInvoiceOrderModel[];
}

// Modelo para la relación ExpenseInvoice-Order
export interface ExpenseInvoiceOrderModel {
  id: number;
  expenseInvoiceId: number;
  orderId: number;
  originalUrl: string;
  normalizedUrl: string;
  createdDate: Date;
  createdByUserId: number;
  order?: any; // OrderAdminDto type would need to be imported
}

// Filtros para la tabla
export interface IExpenseInvoiceTableFilters {
  name: string;
  providerEmail: string;
  orderId: string; // Filtro por ID de pedido (alfanumérico, con o sin #)
  finalUrl: string; // Filtro por URL final/publicada
  fromDate?: Dayjs | null;
  toDate?: Dayjs | null;
  status?: ExpenseStatusEnum | null;
  paymentMethod?: ExpensePaymentMethodEnum | null;
  currency?: ExpenseCurrencyEnum | null;
  minAmount?: number;
  maxAmount?: number;
}

// Request para obtener gastos paginados
export interface GetPaginatedExpenseInvoicesRequest extends IExpenseInvoiceTableFilters {
  page: number;
  pageSize: number;
  orderBy?: string;
  orderDirection?: string;
}

// Response paginado
export interface ExpenseInvoicePaginatorResponse extends PaginatorResponse<ExpenseInvoiceModel> {
  statusCounts?: Record<string, number>;
  statusTotals?: Record<string, number>;
  currencyCounts?: Record<string, number>;
  paymentMethodCounts?: Record<string, number>;
}

// DTO para crear/actualizar gasto externo
export interface CreateExpenseInvoiceDto {
  name: string;
  concept?: string;
  providerEmail: string;
  paymentMethod: ExpensePaymentMethodEnum;
  language: string;
  currency: ExpenseCurrencyEnum;
  amount: number;
  status: ExpenseStatusEnum;
  file?: File;
  expenseType: ExpenseTypeEnum;
  orders?: any[]; // OrderAdminDto array
}
